<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="search.name" placeholder="项目名" class="filter-item" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-select v-model="search.status" placeholder="状态" class="filter-item" style="width: 130px" clearable>
        <el-option v-for="item in option.status" :key="item.key" :label="item.val" :value="item.key"/>
      </el-select>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
      <el-button type="primary" class="filter-item" style="margin-left: 10px;" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>

    <el-table v-loading="listLoading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="项目名称" align="center" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目描述">
        <template slot-scope="scope">
          <span>{{ scope.row.intro }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.start }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="150" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="预测记录" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleForecast(scope.row)">
              <svg-icon icon-class="forecast"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="!temp.id? '添加': '编辑'" :visible.sync="dia.edit">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="80px" style="max-width: 400px; margin-left:50px;">
        <el-form-item label="ID" prop="code" v-if="temp.id">
          <span>{{ temp.id }}</span>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="temp.name" placeholder="请填写名称"/>
        </el-form-item>
        <el-form-item label="开始时间" prop="start">
          <el-date-picker v-model="temp.start" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="项目描述" prop="intro">
          <el-input v-model="temp.intro" type="textarea" :row="4" placeholder="简单介绍项目情况"/>
        </el-form-item>
        <el-form-item label="人员" prop="user">
          <el-select v-model="temp.user" multiple placeholder="请选择" style="width: 100%">
            <el-option label="团队所有人" :value="0"></el-option>
            <el-option v-for="row in user" :key="row.id" :label="row.name" :value="row.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" v-for="(row, idx) in option.status" :key="idx" :label="row.key">{{ row.val }}</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dia.edit = false">取消</el-button>
        <el-button type="primary" @click="saveData">确定</el-button>
      </div>
    </el-dialog>
    <!-- edit -->

    <el-dialog class="dia" title="预测记录" :visible.sync="dia.forecast">
      <el-table v-loading="listLoading" :data="forecast" border fit highlight-current-row style="width: 100%;">
        <el-table-column label="名称" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建日期" align="center" width="140px">
          <template slot-scope="scope">
            <span>{{ scope.row.time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="center" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.user }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- forecast -->

  </div>
</template>

<script>
import waves from '@/directive/waves'

const option = {
  status: [{key: '1', val: '可用'}, {key: '0', val: '停用'}]
}

export default {
  name: 'AdminProject',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      let data = option.status.find(row => row.key == key)
      return data.val || '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      search: {
        page: 1,
        size: 12,
        name: '',
        status: ''
      },
      option: option,
      user: [],
      dia: {
        edit: false,
        forecast: false
      },
      temp: {},
      forecast: [],

      rules: {
        name: [{ required: true, message: '请填写项目名称', trigger: 'blur' }],
        intro: [{ required: true, message: '请简要介绍项目情况', trigger: 'blur' }],
        start: [{ required: true, message: '请选择项目开始时间', trigger: 'change' }],
        user: [{ required: true, message: '请选择人员', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.init()
    this.getList()
  },
  methods: {
    init() {
      const _t = this
      _t.$http.post('/api/project/user', _t.search).then(resp => {
        _t.user = resp.data
      })
    },
    getList() {
      const _t = this
      _t.listLoading = true
      _t.$http.post('/api/project/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleCreate() {
      this.temp = {}
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/project/save', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    },
    handleForecast(row) {
      this.temp = Object.assign({}, row)
      this.dia.forecast = true
      this.getForecast()
    },
    getForecast() {
      const _t = this
      const data = {
        id: _t.temp.id
      }
      _t.$http.post('/api/project/forecast', data).then(resp => {
        _t.forecast = resp.data
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.dia {
  .tip {
    color: $dark;
    font-size: 12px;
  }
}
</style>

